import * as React from "react";
import { DatasheetFieldComponentOriginFieldGetDto } from "@common/dto/datasheet/field-component/origin-field-dto";

import "./column.styles.scss";

export type HeaderColumnProps = {
  title: string;
  width: number;
  onResizeEnd: (params: { field: DatasheetFieldComponentOriginFieldGetDto }) => void;
  containerRef?: React.RefObject<HTMLElement>;
  field: DatasheetFieldComponentOriginFieldGetDto;
};

export const HeaderColumn = ({ width = 0, onResizeEnd, title, containerRef, field }: HeaderColumnProps) => {
  const resizableElementRef = React.useRef<HTMLDivElement>(null);
  const minColumnWidth = 5;

  const [size, setSize] = React.useState({ width });
  const [resizing, setResizing] = React.useState(false);

  const handleResizingFinished = () => {
    console.log("handleResizingFinished");
    onResizeEnd({
      field: {
        ...field,
        ...size,
      },
    });
  };

  const handleResize = (e: MouseEvent) => {
    if (!resizing) {
      return;
    }

    if (resizableElementRef.current) {
      const datasheetElementRect = resizableElementRef.current.getBoundingClientRect();
      const newSize = { ...size };

      newSize.width = e.clientX - datasheetElementRect.x;

      const finalSize = {
        width: Math.max(minColumnWidth, newSize.width),
      };

      setSize(finalSize);
    }
  };

  const resetResizing = React.useCallback(() => {
    setResizing(false);
  }, []);

  const initMouseUp = React.useCallback(
    (e: MouseEvent) => {
      handleResize(e);
      resetResizing();
    },
    [handleResize, resetResizing]
  );

  const handleResizing = React.useCallback((e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    setResizing(true);
  }, []);

  React.useEffect(() => {
    if (containerRef?.current) {
      containerRef.current.addEventListener("mouseup", initMouseUp);

      return () => {
        containerRef.current?.removeEventListener("mouseup", initMouseUp);
      };
    }
  }, [resizing]);

  return (
    <div className="DatasheetsResultDatasheetTableFieldHeaderColumn">
      <div
        ref={resizableElementRef}
        className="DatasheetsResultDatasheetTableFieldHeaderColumn__title"
        style={{
          width: size.width,
        }}
      >
        {title}
      </div>

      <div
        className="DatasheetsResultDatasheetTableFieldHeaderColumn__resizer"
        onMouseDown={handleResizing}
        onMouseUp={handleResizingFinished}
      />
    </div>
  );
};
